"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Vimeo = require("./Vimeo");

var _Vimeo2 = _interopRequireDefault(_Vimeo);

var _Youtube = require("./Youtube");

var _Youtube2 = _interopRequireDefault(_Youtube);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Video = /*#__PURE__*/function (_Component) {
  _inherits(Video, _Component);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, _getPrototypeOf(Video).apply(this, arguments));
  }

  _createClass(Video, [{
    key: "render",
    value: function render() {
      var url = this.props.url;

      if (url.search('vimeo') !== -1) {
        return _react2["default"].createElement(_Vimeo2["default"], this.props);
      }

      if (url.search('youtube') !== -1) {
        return _react2["default"].createElement(_Youtube2["default"], this.props);
      }

      return null;
    }
  }], [{
    key: "getThumbUrl",
    value: function getThumbUrl(url, thumbWidth, apiKey) {
      if (url.search('vimeo') !== -1) {
        return _Vimeo2["default"].getThumbUrl(url, thumbWidth);
      }

      if (url.search('youtube') !== -1) {
        return _Youtube2["default"].getThumbUrl(url, apiKey);
      }

      return Promise.reject("Unsupported video url format, ".concat(url));
    }
  }]);

  return Video;
}(_react.Component);

Video.propTypes = {
  /** Video url */
  url: _propTypes2["default"].string.isRequired,

  /** Unique id for iFrame */
  id: _propTypes2["default"].number.isRequired,

  /** Function that receives the video thumbnail URL as prop */
  setThumb: _propTypes2["default"].func,

  /** Desired width for the thumbnail retrieved by the function above */
  thumbWidth: _propTypes2["default"].number,
  className: _propTypes2["default"].string,

  /** Dynamic prop that pauses and plays the video */
  play: _propTypes2["default"].bool,
  apiKey: _propTypes2["default"].string
};
exports["default"] = Video;